import React, { useCallback, useEffect, useState } from "react";
import { TopToolbar } from "react-admin";
import { Button, Chip, Modal, Typography } from "@material-ui/core";
import {
  getPrice,
  getProductName,
  getRefId,
  getTotalCashReceived,
  getTotalCashReturned,
  getTransId,
  renderDate,
  renderDateTime,
  renderGatewayField,
  renderProductSlot,
  renderTime,
  renderTransactionStatus,
  statusForExcelReport,
} from "../../Employee/ValidateCSV";
import CustomizedDialogs from "./TransactionDetails";
import { makeStyles } from "@material-ui/core/styles";
import TransactionFilter from "../../Filters/TransactionFilter";
import { FilterList as FilterListIcon } from "@mui/icons-material";
import { Tab, Table, Tabs } from "react-bootstrap";
import _extendLayout from "../../../layout/_extendLayout";
import axios from "axios";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Paginations from "../../Pagination";
import {
  commercialGeneralTemplate,
  commercialTestTemplate,
} from "../../templates";
import { get } from "lodash";
import { useDataProvider } from "react-admin";

// const parseCashDetails = (details) =>
//   typeof details === "string" ? JSON.parse(details) : (details ?? {});

const renderAdminMoreButtonField = (
  record,
  setDetailsOpen,
  setModalContent,
) => {
  if (!record) return null;
  let parsedResponseStatus = record.ResponseStatus
    ? JSON.parse(record.ResponseStatus)
    : null;

  return (
    <Button
      size="medium"
      onClick={() => {
        setDetailsOpen(true);

        const modalContent = {
          ...record,
          ResponseStatus: parsedResponseStatus,
        };

        setModalContent(JSON.stringify(modalContent, null, 2));
      }}
    >
      &gt;
    </Button>
  );
};

const renderCustomerMoreButtonField = (
  record,
  setDetailsOpen,
  setModalContent,
) => {
  if (!record) return null;
  return (
    <button
      style={{ border: "none", background: "none", cursor: "pointer" }}
      size="medium"
      onClick={() => {
        setDetailsOpen(true);
        setModalContent(
          <CustomizedDialogs
            record={record}
            open={true}
            onClose={() => setDetailsOpen(false)}
          />,
        );
      }}
    >
      &gt;
    </button>
  );
};

const SalesTransactionList = (props) => {
  const classes = useStyles();

  const [isAdmin, setIsAdmin] = useState(false);
  const [clientId, setClientId] = useState("");
  const [salesList, setSalesList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [total, setTotal] = useState(0);
  const [salesPage, setSalesPage] = useState(1);
  const [orderPage, setOrderPage] = useState(1);
  const [perPage] = useState(25);
  const [transactionFilters, setTransactionFilters] = useState([]);
  const [orderFilters, setOrderFilters] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [orderList, setOrderList] = useState([]);
  const [filteredOrderData, setFilteredOrderData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("transaction");
  const [salesSortField, setSalesSortField] = useState("Date");
  const [salesSortOrder, setSalesSortOrder] = useState("DESC");
  const [orderSortField, setOrderSortField] = useState("Date");
  const [orderSortOrder, setOrderSortOrder] = useState("DESC");
  const [salesFilter, setSalesFilter] = useState({});
  const [ordersFilter, setOrdersFilter] = useState({});
  const [mode, setMode] = useState("commercial");
  const dataProvider = useDataProvider();

  const handleTabChange = (key) => {
    setActiveTab(key);

    if (key === "transaction") {
      setOrderFilters([]);
    } else if (key === "order") {
      setTransactionFilters([]);
    }
  };

  const getCurrentUser = async () => {
    try {
      let token = localStorage.getItem("token");
      const res = decodeJWT(token);
      const isAdminUser = res.role === "admin";
      const machineMode = await getMachineMode(res);
      setIsAdmin(isAdminUser);
      setMode(machineMode);
      if (!isAdminUser) setClientId(res.client_id);
      return isAdminUser
        ? { mode: machineMode }
        : { client: res.client_id, mode: machineMode };
    } catch (err) {
      console.log(err);
    }
  };

  const decodeJWT = (token) => {
    const parts = token.split(".");

    if (parts.length !== 3) {
      throw new Error("Invalid token format");
    }

    const payload = parts[1];
    return JSON.parse(base64Decode(payload));
  };

  const base64Decode = (str) => {
    const padding = "=".repeat((4 - (str.length % 4)) % 4);
    const base64 = (str + padding).replace(/-/g, "+").replace(/_/g, "/");
    return decodeURIComponent(escape(atob(base64)));
  };

  const getMachineMode = async (user) => {
    if (!user.client_id) return "commercial";

    const machinesRes = await dataProvider.getList("machines", {
      filter: { "client.id": user.client_id, isDeleted: false },
      pagination: { page: 1, perPage: 100 },
      sort: {},
    });
    const machines = machinesRes.data || [];
    return machines.some((machine) => machine.machineMode === "event")
      ? "event"
      : "commercial";
  };

  const getTransactionList = async (filter, pagination, sort) => {
    setLoading(true);
    try {
      let token = localStorage.getItem("token");

      let skip = (pagination.page - 1) * pagination.perPage;
      let limit = pagination.perPage;
      let sortField = sort.field || "Date";
      let sortOrder = sort.order || "DESC";
      let params = {
        ...filter,
        skip,
        limit,
        sortField: sortField,
        sortOrder: sortOrder,
        mode: filter.mode || "commercial",
      };

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/machine_transaction/salesList`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      const newFilteredData = res.data.result.data;
      if (Array.isArray(newFilteredData)) {
        const formattedData = newFilteredData.map((item) => ({
          ...item,
          id: item.TransactionId,
        }));

        setFilteredData(formattedData);
        setSalesList(formattedData);
        setTotal(res.data.result.total);
        setTotalAmount(
          formattedData.reduce(
            (sum, item) => sum + (parseFloat(item.Amount) || 0),
            0,
          ),
        );
      } else {
        console.error("Invalid data format:", newFilteredData);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const getOrderList = async (filter, pagination, sort) => {
    setLoading(true);
    try {
      let token = localStorage.getItem("token");

      let skip = (pagination.page - 1) * pagination.perPage;
      let limit = pagination.perPage;
      let sortField = sort.field || "Date";
      let sortOrder = sort.order || "DESC";

      let params = {
        ...filter,
        skip,
        limit,
        sortField,
        sortOrder,
      };

      params.mode = "commercial";

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/machine_transaction/orderList`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      const newFilteredData = res.data.result.data;
      if (Array.isArray(newFilteredData)) {
        const formattedData = newFilteredData.map((item) => ({
          ...item,
          id: item.TransactionId,
        }));

        setFilteredOrderData(formattedData);
        setOrderList(formattedData);
        setTotal(res.data.result.total);
      } else {
        console.error("Invalid data format:", newFilteredData);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const CustomActions = React.memo(
    ({
      totalAmount = 0,
      showTotalAmount = true,
      showExport = true,
      ...props
    }) => {
      const combineExporter = () => {
        if (activeTab === "transaction") {
          return props.salesExporter();
        } else {
          return orderExporter();
        }
      };

      return (
        <TopToolbar
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              flex: 1,
            }}
          >
            {/* Sum of product price */}
            {showTotalAmount && (
              <Typography variant="h6">
                Total Price: RM {totalAmount.toFixed(2)}
              </Typography>
            )}
          </div>
          {/* Render Filter Tags */}
          {(activeTab === "transaction"
            ? transactionFilters
            : orderFilters
          ).map((filter, index) => (
            <Chip
              key={index}
              label={`${filter.key} = ${filter.value}`}
              color="primary"
            />
          ))}
          <Button
            startIcon={<FilterListIcon />}
            onClick={() => props.onShowFilters()}
            variant="outlined"
            color="primary"
            style={{ border: "none" }}
          >
            Show Filters
          </Button>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <TransactionFilter
              key={`sales-${activeTab}-filters`}
              storageKey={`sales-${activeTab}-filters`}
              setFilteredData={handleFilteredData}
              allData={salesList}
              onModalOpenChange={handleModalOpenChange}
              modalOpen={modalOpen}
              setAppliedFilters={
                activeTab === "transaction"
                  ? setTransactionFilters
                  : setOrderFilters
              }
              setTotalAmount={setTotalAmount}
              setTotal={setTotal}
              setFilter={
                activeTab === "transaction" ? setSalesFilter : setOrdersFilter
              }
              mode={mode}
              clientId={clientId}
              sales={{
                sales: true,
                module: activeTab === "transaction" ? "transaction" : "order",
              }}
            />
            {showExport && (
              <Button
                color="primary"
                startIcon={<FileDownloadIcon />}
                onClick={combineExporter}
              >
                Export
              </Button>
            )}
          </div>
        </TopToolbar>
      );
    },
  );

  const handleModalOpenChange = useCallback((isOpen) => {
    setModalOpen(isOpen);
  }, []);

  const handleFilteredData = (newFiltered) => {
    const formattedData = Array.isArray(newFiltered)
      ? newFiltered.map((item) => ({
          ...item,
          id: item.TransactionId,
        }))
      : [];
    if (activeTab === "order") {
      setFilteredOrderData(formattedData);
      setOrderList(formattedData);
    } else {
      setFilteredData(formattedData);
      setSalesList(formattedData);
    }
  };

  const fetchExportRows = async (endpoint, filter, sort) => {
    const token = localStorage.getItem("token");
    const params = {
      ...filter,
      skip: 0,
      limit: 100000,
      sortField: sort.field || "Date",
      sortOrder: sort.order || "DESC",
      mode: endpoint.includes("salesList") ? filter.mode || mode : "commercial",
    };

    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}${endpoint}`,
      {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    const result = res.data.result.data;
    if (!Array.isArray(result)) return [];

    return result.map((item) => ({
      ...item,
      id: item.TransactionId,
    }));
  };

  const salesExporter = async () => {
    try {
      const template = commercialTestTemplate;
      const exportData = await fetchExportRows(
        "/machine_transaction/salesList",
        salesFilter,
        { field: salesSortField, order: salesSortOrder },
      );

      const processedData = exportData
        .filter((e) => isAdmin || e.Client === clientId)
        .map((e) => ({
          ...e,
          amount: e.Amount,
          date: renderDateTime(e),
          remark: e.Payment?.remark ?? "",
          paymentType: e.Payment?.paymentType ?? "",
          paymentGateway: renderGatewayField(e),
          cash: e.Payment?.cash ?? "",
          machine: { machineUUID: e.Machine?.machineUUID ?? "" },
          mode: e.Mode ?? "",
          payment: {
            paymentAmount: e.Payment?.amount ?? "",
            refundAmount: e.Payment?.refundAmount ?? "",
          },
          status: statusForExcelReport(e.Status),
          transId: getTransId(e),
          product: {
            name: getProductName(e),
            slot: e.Product?.slot ?? "",
            sku: e.Product?.sku ?? "",
            serialNumber: e.Product?.serialNumber ?? "",
          },
          terminal: e.Payment?.terminal ?? "",
          quantity: e.Quantity ?? "",
          cashInDetails: e.CashInDetails ?? "",
          cashOutDetails: e.CashOutDetails ?? "",
          error: {
            message: e.Error?.description ?? "",
          },
        }));

      const csv = generateCSV(processedData, template);

      // filterData.forEach(e => {

      //     const date = renderDate(e);
      //     const time = renderTime(e);
      //     const slot = renderProductSlot(e);
      //     const gateway = renderGatewayField(e);
      //     const status = statusForExcelReport(e.Status);
      //     const totalCashReceived = getTotalCashReceived(e);
      //     const totalCashReturned = getTotalCashReturned(e);
      //     const transId = getTransId(e);
      //     const refId = getRefId(e);
      //     const balance = totalCashReceived && totalCashReturned ? totalCashReceived - totalCashReturned : "";
      //     const productName = getProductName(e);
      //     const price = getPrice(e);

      //     const commonDetails = [
      //         e.id,
      //         e.Machine.machineUUID ?? "",
      //         date ?? "",
      //         time ?? "",
      //         productName ?? "",
      //         slot ?? "",
      //         price ?? "",
      //         gateway ?? "",
      //         status ?? "",
      //         totalCashReceived ?? "",
      //         totalCashReturned ?? "",
      //         balance ?? "",
      //         transId ?? "",
      //         refId ?? "",
      //     ];
      //     csvRows.push([...commonDetails].join(","));
      // });

      const machineUUIDs = [
        ...new Set(
          processedData.map((e) => e.machine?.machineUUID).filter(Boolean),
        ),
      ];

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download =
        machineUUIDs.length === 1
          ? `${machineUUIDs[0]}.csv`
          : "Transactions.csv";
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.log(err);
    }
  };

  const orderExporter = async () => {
    try {
      const exportData = await fetchExportRows(
        "/machine_transaction/orderList",
        ordersFilter,
        { field: orderSortField, order: orderSortOrder },
      );
      const headers = [
        "Order ID",
        "Document ID",
        "Machine UUID",
        "Date",
        "Time",
        "Product",
        "Slot",
        "Price",
        "Gateway",
        "Status",
        "Total Cash Received",
        "Total Cash Returned",
        "Balance",
        "Transaction ID",
        "Reference No",
      ];

      let csvRows = [headers.join(",")];

      exportData.forEach((e) => {
        const date = renderDate(e);
        const time = renderTime(e);
        const slot = renderProductSlot(e);
        const gateway = renderGatewayField(e);
        const status = statusForExcelReport(e.Status);
        const totalCashReceived = getTotalCashReceived(e);
        const totalCashReturned = getTotalCashReturned(e);
        const transId = getTransId(e);
        const refId = getRefId(e);
        const balance =
          totalCashReceived && totalCashReturned
            ? totalCashReceived - totalCashReturned
            : "";
        const productName = getProductName(e);
        const price = getPrice(e);

        const commonDetails = [
          e.OrderNo,
          e.id,
          e.Machine.machineUUID ?? "",
          date ?? "",
          time ?? "",
          productName ?? "",
          slot ?? "",
          price ?? "",
          gateway ?? "",
          status ?? "",
          totalCashReceived ?? "",
          totalCashReturned ?? "",
          balance ?? "",
          transId ?? "",
          refId ?? "",
        ];
        csvRows.push([...commonDetails].join(","));
      });

      const csvContent = csvRows.join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Order Transactions.csv";
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.log(err);
    }
  };

  const handleSearchInput = (query) => {
    if (query) {
      const filtered = salesList.filter((item) =>
        ["machine.machineUUID"].some((key) => {
          const value = key
            .split(".")
            .reduce((acc, part) => acc && acc[part], item);
          return (
            value &&
            value.toString().toLowerCase().includes(query.toLowerCase())
          );
        }),
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(salesList);
    }
  };

  const handleSortChange = (field) => {
    setSalesSortField(field);
    setSalesSortOrder((prevSortOrder) => {
      const newOrder = prevSortOrder === "ASC" ? "DESC" : "ASC";
      return newOrder;
    });
  };

  const handleOrderSortChange = (field) => {
    setOrderSortField(field);
    setOrderSortOrder((pre) => {
      const newOrder = pre === "ASC" ? "DESC" : "ASC";
      return newOrder;
    });
  };

  const generateCSV = (data, template) => {
    if (!Array.isArray(data) || data.length === 0) return "";

    const headers = template.map((col) => col.label);
    const fields = template.map((col) => col.field);

    const csvRows = [headers.join(",")];

    data.forEach((row) => {
      const rowData = fields.map((field) => {
        const value = get(row, field, "");
        const escaped = String(value).replace(/"/g, '""');
        return `"${escaped}"`;
      });
      csvRows.push(rowData.join(","));
    });

    return csvRows.join("\n");
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const user = await getCurrentUser();
      if (activeTab === "transaction") {
        await getTransactionList(
          { ...salesFilter, ...user },
          { page: salesPage, perPage: perPage },
          { field: salesSortField, order: salesSortOrder },
        );
      } else {
        await getOrderList(
          { ...ordersFilter, ...user },
          { page: orderPage, perPage: perPage },
          { field: orderSortField, order: orderSortOrder },
        );
      }
    };

    fetchData();
  }, [
    activeTab,
    salesPage,
    orderPage,
    salesSortField,
    salesSortOrder,
    orderSortField,
    orderSortOrder,
  ]);
  return (
    <>
      <_extendLayout isModalOpen={modalOpen || detailsOpen}>
        <div style={{ width: "90%" }}>
          <h4 className="">Sales Transaction Report</h4>
          <Tabs
            defaultActiveKey="transaction"
            className="m-3"
            onSelect={handleTabChange}
          >
            <Tab eventKey="transaction" title="Transaction List">
              {loading ? (
                <Typography>Loading...</Typography>
              ) : salesList.length === 0 ? (
                <div>
                  <CustomActions
                    totalAmount={totalAmount}
                    showTotalAmount={true}
                    showExport={false}
                    onShowFilters={() => setModalOpen(true)}
                    handleModalOpenChange={handleModalOpenChange}
                    isModalOpen={modalOpen}
                    setFilteredData={setFilteredData}
                    data={salesList}
                    salesExporter={salesExporter}
                    setTotalAmount={setTotalAmount}
                    activeTab={activeTab}
                  />
                </div>
              ) : (
                <div>
                  <CustomActions
                    totalAmount={totalAmount}
                    showTotalAmount={true}
                    onShowFilters={() => setModalOpen(true)}
                    handleModalOpenChange={handleModalOpenChange}
                    isModalOpen={modalOpen}
                    setFilteredData={setFilteredData}
                    data={salesList}
                    salesExporter={salesExporter}
                    setTotalAmount={setTotalAmount}
                    activeTab={activeTab}
                  />
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th
                          onClick={() =>
                            handleSortChange("Machine.machineUUID")
                          }
                          style={{ cursor: "pointer" }}
                        >
                          Machine UUID{" "}
                          {salesSortField === "Machine.machineUUID" &&
                            (salesSortOrder === "ASC" ? "↑" : "↓")}
                        </th>
                        <th>Date</th>
                        <th>Time</th>
                        {isAdmin && <th>Company Name</th>}
                        <th
                          onClick={() => handleSortChange("Product.name")}
                          style={{ cursor: "pointer" }}
                        >
                          Product Name{" "}
                          {salesSortField === "Product.name" &&
                            (salesSortOrder === "ASC" ? "↑" : "↓")}
                        </th>
                        <th
                          onClick={() => handleSortChange("Product.slot")}
                          style={{ cursor: "pointer" }}
                        >
                          Product Slot{" "}
                          {salesSortField === "Product.slot" &&
                            (salesSortOrder === "ASC" ? "↑" : "↓")}
                        </th>
                        <th
                          onClick={() => handleSortChange("Amount")}
                          style={{ cursor: "pointer" }}
                        >
                          Product Price{" "}
                          {salesSortField === "Amount" &&
                            (salesSortOrder === "ASC" ? "↑" : "↓")}
                        </th>
                        <th>Gateway</th>
                        <th>Status</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.length === 0 ? (
                        <tr>
                          <td
                            colSpan={isAdmin ? 10 : 9}
                            style={{ textAlign: "center", padding: "1rem" }}
                          >
                            No data found
                          </td>
                        </tr>
                      ) : (
                        filteredData.map((item, index) => (
                          <tr key={item.TransactionId}>
                            <td>{item.Machine.machineUUID}</td>
                            <td>{renderDate(item)}</td>
                            <td>{renderTime(item)}</td>
                            {isAdmin && <td>{item.companyName}</td>}
                            <td>{item?.Product?.name}</td>
                            <td>{renderProductSlot(item)}</td>
                            <td>{item.Amount}</td>
                            <td>{renderGatewayField(item)}</td>
                            <td>{renderTransactionStatus(item)}</td>
                            <td>
                              {isAdmin
                                ? renderAdminMoreButtonField(
                                    item,
                                    setDetailsOpen,
                                    setModalContent,
                                  )
                                : renderCustomerMoreButtonField(
                                    item,
                                    setDetailsOpen,
                                    setModalContent,
                                  )}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Paginations
                      total={total}
                      currentPage={salesPage}
                      perPage={perPage}
                      onPageChange={(page) => setSalesPage(page)}
                    />
                  </div>
                </div>
              )}
            </Tab>
            <Tab eventKey="order" title="Order List">
              {loading ? (
                <Typography>Loading...</Typography>
              ) : orderList.length === 0 ? (
                <Typography>No data found</Typography>
              ) : (
                <div>
                  <CustomActions
                    totalAmount={totalAmount}
                    showTotalAmount={false}
                    onShowFilters={() => setModalOpen(true)}
                    handleModalOpenChange={handleModalOpenChange}
                    isModalOpen={modalOpen}
                    setFilteredData={setFilteredData}
                    data={orderList}
                    salesExporter={salesExporter}
                    setTotalAmount={setTotalAmount}
                    activeTab={activeTab}
                  />
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th>Order ID</th>
                        <th>ID</th>
                        <th
                          onClick={() =>
                            handleOrderSortChange("Machine.machineUUID")
                          }
                          style={{ cursor: "pointer" }}
                        >
                          Machine UUID{" "}
                          {orderSortField === "Machine.machineUUID" &&
                            (orderSortOrder === "ASC" ? "↑" : "↓")}
                        </th>
                        <th>Date</th>
                        <th>Time</th>
                        {isAdmin && <th>Company Name</th>}
                        <th
                          onClick={() => handleOrderSortChange("Product.name")}
                          style={{ cursor: "pointer" }}
                        >
                          Product Name{" "}
                          {orderSortField === "Product.name" &&
                            (orderSortOrder === "ASC" ? "↑" : "↓")}
                        </th>
                        <th
                          onClick={() => handleOrderSortChange("Product.slot")}
                          style={{ cursor: "pointer" }}
                        >
                          Product Slot{" "}
                          {orderSortField === "Product.slot" &&
                            (orderSortOrder === "ASC" ? "↑" : "↓")}
                        </th>
                        <th
                          onClick={() => handleOrderSortChange("Amount")}
                          style={{ cursor: "pointer" }}
                        >
                          Product Price{" "}
                          {orderSortField === "Amount" &&
                            (orderSortOrder === "ASC" ? "↑" : "↓")}
                        </th>
                        <th>Gateway</th>
                        <th>Status</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredOrderData.length === 0 ? (
                        <tr>
                          <td
                            colSpan={isAdmin ? 12 : 11}
                            style={{ textAlign: "center", padding: "1rem" }}
                          >
                            No data found
                          </td>
                        </tr>
                      ) : (
                        filteredOrderData.map((item, index) => (
                          <tr key={item.TransactionId}>
                            <td>{item.OrderRefNo}</td>
                            <td>{item.TransactionId}</td>
                            <td>{item.Machine.machineUUID}</td>
                            <td>{renderDate(item)}</td>
                            <td>{renderTime(item)}</td>
                            {isAdmin && <td>{item.companyName}</td>}
                            <td>{item?.Product?.name}</td>
                            <td>{renderProductSlot(item)}</td>
                            <td>{item.Amount}</td>
                            <td>{renderGatewayField(item)}</td>
                            <td>{renderTransactionStatus(item)}</td>
                            <td>
                              {isAdmin
                                ? renderAdminMoreButtonField(
                                    item,
                                    setDetailsOpen,
                                    setModalContent,
                                  )
                                : renderCustomerMoreButtonField(
                                    item,
                                    setDetailsOpen,
                                    setModalContent,
                                  )}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Paginations
                      total={total}
                      urrentPage={orderPage}
                      perPage={perPage}
                      onPageChange={(page) => setOrderPage(page)}
                    />
                  </div>
                </div>
              )}
            </Tab>
          </Tabs>
        </div>
        <Modal open={detailsOpen} onClose={() => setDetailsOpen(false)}>
          <div className={classes.paper}>
            {typeof modalContent === "string" ? (
              <pre>{modalContent}</pre>
            ) : (
              modalContent
            )}
          </div>
        </Modal>
      </_extendLayout>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 500,
    maxHeight: "90%",
    overflow: "scroll",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

export default SalesTransactionList;
